import React from 'react';

import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';
import { BaseItemPage, WithLangs } from '@common/typescript/objects/Page';

import '@app/scss/pages/privacyPolicy.scss';

const PrivacyPolicy: React.FC = () => {
	return <ServerPageProvider<BaseItemPage<any> & WithLangs<any>>
		path="privacy-policy"
		defaultTitle="Privacy Policy"
		inner={(serverPage) => {
			const data = serverPage.langs.find((item) => item.lang === 'En');
			return <div className="container privacy-policy">
				<div className="privacy-policy__inner">
					<div dangerouslySetInnerHTML={{ __html: data?.body || '' }} />
				</div>
			</div>;
		}}
	/>;
};

export default PrivacyPolicy;
